var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");
name.prefix = require("./prefix");
name.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/name/index.js
// module id = 1789
// module chunks = 1